const PRODUCTION_URL_REGEX = /(www|static|canary)\.tradera\.(com|se|net)/;
const STAGING_URL_REGEX = /(beta-(a|b|c|verify)\.)tradera\.com/;
const DEVELOPMENT_URL_REGEXES = [
    /webpack-internal:\/\//,
    /localhost:\d+/,
    /127\.0\.0\.1:\d+/,
    /10\.\d+\.\d+\.\d+:\d+/,
    /192\.168.\.\d+\.\d+:\d+/,
    /((\w|-)+\.)+tradera\.(dev|service)/
];

const getRequestUrl = event => {
    try {
        return new URL(event.request.url);
    } catch (error) {
        return {};
    }
};

const isDebuggingEnabled = searchParams => searchParams?.has?.('debug-sentry');

export const SHARED_CONFIG = {
    maxBreadcrumbs: 25,
    normalizeDepth: 5,
    allowUrls: [
        PRODUCTION_URL_REGEX,
        STAGING_URL_REGEX,
        ...DEVELOPMENT_URL_REGEXES
    ],
    denyUrls: [
        /chrome:\/\//i,
        /extensions\//i,
        /moz-extension:\/\//i,
        /graph\.facebook\.com/i,
        /connect\.facebook\.net\/en_US\/all\.js/i,
        /pixelsafe\.adsafeprotected.com/,
        /gstatic/,
        /gpt/i,
        /metrics\.itunes\.apple\.com\.edgesuite\.net/i,
        /cdn\.ampproject\.org/i,
        /adform\.net/i
    ],
    ignoreErrors: [
        'Loading chunk',
        'Loading CSS chunk',
        'TypeError: Failed to fetch',
        // https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
        'ResizeObserver loop limit exceeded',
        // Google Translate extension: https://github.com/getsentry/sentry-javascript/issues/2418
        `TypeError: a[b].target.className.indexOf is not a function. (In 'a[b].target.className.indexOf(Zb)', 'a[b].target.className.indexOf' is undefined)`,
        'UET is not defined',
        'should_do_lastpass_here',
        // Error generated by a bug in SamsungBrowser/7.2
        'document.getElementsByClassName.ToString is not a function',
        `ReferenceError: Can't find variable: MoatMAK`
    ]
};

export const getEnvironmentFromOrigin = origin => {
    if (PRODUCTION_URL_REGEX.test(origin)) {
        return 'production';
    }
    if (STAGING_URL_REGEX.test(origin)) {
        return 'staging';
    }
    if (DEVELOPMENT_URL_REGEXES.some(regex => regex.test(origin))) {
        return 'development';
    }
    if (process?.env?.SENTRY_ENVIRONMENT) {
        return process.env.SENTRY_ENVIRONMENT;
    }
    if (process?.env?.NODE_ENV) {
        return process.env.NODE_ENV;
    }
    return 'unknown';
};

export const beforeSend = ({ event, hint, isServer }) => {
    const requestUrl = getRequestUrl(event);
    const environment = getEnvironmentFromOrigin(requestUrl?.origin);
    if (isServer) {
        console.error(hint.originalException || hint.syntheticException);
    } else {
        console.error(
            hint.originalException || hint.syntheticException,
            event // Logs all data that would have been sent to Sentry (such as context & tags)
        );
    }
    const debugSentry = isDebuggingEnabled(requestUrl?.searchParams);
    if (!debugSentry && environment === 'development') {
        // Do not send error to Sentry in development
        return null;
    }
    return event;
};

export const tracesSampler = ({ urlSearchParams, parentSampled }) => {
    if (parentSampled !== undefined) {
        // Inherit parent transaction sampling for complete traces
        return parentSampled;
    }
    const searchParams = new URLSearchParams(urlSearchParams);
    const debugSentry = isDebuggingEnabled(searchParams);
    if (debugSentry) {
        return 1;
    }
    return parseFloat(process.env.SENTRY_SAMPLE_RATE) || 1;
};
